import React, { useState, useEffect } from "react"

import { makeStyles } from "@mui/styles"
import Button from "@mui/material/Button"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import IconButton from "@mui/material/IconButton"

import DoneIcon from "@mui/icons-material/Done"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"

import api from "../../services/api"
import TableRowSkeleton from "../../components/TableRowSkeleton"
import { green } from "@mui/material/colors"
import DialogActions from "@mui/material/DialogActions"
import { toast } from "react-toastify"
import { fCurrency } from "../../utils/formatNumbers"

const useStyles = makeStyles((theme) => ({
    mainPaper: {
        flex: 1,
        padding: theme.spacing(1),
        overflowY: "scroll",
        ...theme.scrollbarStyles,
    },

    root: {
        display: "flex",
        flexWrap: "wrap",
    },
    multFieldLine: {
        display: "flex",
        "& > *:not(:last-child)": {
            marginRight: theme.spacing(1),
        },
    },

    btnWrapper: {
        position: "relative",
    },

    buttonProgress: {
        color: green[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    uploadButtonHolder: {
        paddingTop: "10px",
        paddingBottom: "10px",
    },
    buttonIcon: {
        display: "flex",
        justifyContent: "center",
    },
    sendMessageIcons: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    center: {
        display: "flex",
        justifyContent: "center",
    },
    recorderWrapper: {
        display: "flex",
        alignItems: "center",
        alignContent: "middle",
    },

    cancelAudioIcon: {
        color: "red",
    },

    sendAudioIcon: {
        color: "green",
    },
}))

function ModalListProdutos({ open, handleClose, handleAdd }) {
    const classes = useStyles()
    const [products, setProducts] = useState([])

    async function getProducts() {
        try {
            const response = await api.get("/products")
            setProducts(response.data)
        } catch (error) {
            toast.error("Erro ao buscar produtos")
        }
    }

    useEffect(() => {
        if (open) {
            getProducts()
        }
    }, [open])

    return (
        <div className={classes.root}>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
                scroll="paper"
            >
                <DialogTitle id="form-dialog-title">
                    Selecionar produto
                </DialogTitle>

                <div className={classes.center}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center"></TableCell>
                                <TableCell align="center">Produto</TableCell>
                                <TableCell align="center">Descrição</TableCell>
                                <TableCell align="center">Preço</TableCell>
                                <TableCell align="center">Adicionar</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <>
                                {products.map((product) => (
                                    <TableRow key={product.id}>
                                        <TableCell align="center">
                                            <img
                                                width={50}
                                                height={50}
                                                src={
                                                    product.medias[0]
                                                        ?.fileFullURL
                                                }
                                                style={{
                                                    objectFit: "cover",
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            {product.name}
                                        </TableCell>
                                        <TableCell align="center">
                                            {product.description}
                                        </TableCell>
                                        <TableCell align="center">
                                            {fCurrency(product.price)}
                                        </TableCell>
                                        <TableCell align="center">
                                            <IconButton
                                                onClick={() =>
                                                    handleAdd(product)
                                                }
                                            >
                                                <DoneIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {!products?.length && (
                                    <TableRowSkeleton columns={4} />
                                )}
                            </>
                        </TableBody>
                    </Table>
                </div>

                <DialogActions>
                    <Button
                        onClick={handleClose}
                        color="secondary"
                        variant="outlined"
                    >
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ModalListProdutos
